import React, { forwardRef, useState, useContext } from "react";
import cx from "classnames";
import styled from 'styled-components';
import InfoIcon from '../../icons/info-icon.png';
import SVGPass from "./SVGPass";
import SVGFail from "./SVGFail";
import ChecklistItemModal from "./ChecklistItemModal";
import IBuildrProps from '../../utilities/IBuildrProps';
import Picture from "../Picture";

interface IChecklistItemProps extends IBuildrProps {
    index: number;
    dispatch:  (any) => {};
    tabId: number;
    text: string;
    modalText: string;
    modalTitle: string;
    image: string;
    points: number;
    severity: number;
    selections: any[];
    openModal: (title: string, text: string, image: string) => {};
}

export default styled(forwardRef((props: IChecklistItemProps, ref: any) => {
    const { cmsId, index, editorClassObj, className, dispatch, tabId, text, modalText, modalTitle, image, points, severity, selections, openModal } = props;

    const handleSelection = ({index, pass, fail}: {index: number, pass?: boolean, fail?: boolean}) => {
        dispatch({
            type: 'selection',
            index,
            tabId,
            pass,
            fail,
            points: Number(points),
            severity,
        });
    };

    return (
        <>
            <div data-id={cmsId} ref={ref} className={cx(className, editorClassObj)}>
                <div onClick={() => handleSelection({ index, pass: true })} className={cx('severity-indicator', `severity-${severity}`)}>
                    <SVGPass active={selections?.filter(s => s.tabId === tabId)?.find(selection => selection.index === index && selection.pass)} />
                </div>
                <div className="text p-1">
                    {text}
                    {modalText && modalTitle ?
                        <div className="modal-info-icon" onClick={() => openModal(modalTitle, modalText, image)}>
                            <Picture src={InfoIcon} alt="information" />
                        </div>
                        :
                        null
                    }
                </div>
                <div onClick={() => handleSelection({ index, fail: true })}>
                    <SVGFail active={selections?.filter(s => s.tabId === tabId)?.find(selection => selection.index === index && selection.fail)} />
                </div>
            </div>
        </>
    );
}))`
&::first-of-type {
    margin-top: .25rem;
}

border: 1px solid #EFF0F0;
margin-bottom: 10px;
display: flex;
min-height: 65px;

> div {
    padding: 0 20px;
    min-height: 65px;
    display: flex;
    align-items: center;
}
.severity-indicator {
    border-left: 5px solid;
}
.severity-1 { border-color: #5BAE04; }
.severity-2 { border-color: #B9DF20; }
.severity-3 { border-color: #FBF701; }
.severity-4 { border-color: #F7B500; }
.severity-5 { border-color: #FA6400; }
.severity-6 { border-color: #E02020; }
.text {
    flex: 1;
}
.modal-info-icon {
    padding: 15px;
    cursor: pointer;
    &:hover {
        opacity: .7;
    }

    img {
        max-width: 15px;
    }
}
`;